import React from "react";

export const Spinner = ({ float, size, color, message, className }) => (
  <div className={className}>
    <div
      className={"loader " + float}
      style={{
        width: size,
        height: size,
        verticalAlign: "middle",
        color: color,
      }}
    />
    <div className={float}>
      {message && <span className="_primary-text ml-3">{message}</span>}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/common/spinner.js